module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0018.jpg?v=0219e5a3";